import React from "react";

// Official People's Circle mark: blue radial flower / sunburst with yellow center.
const Logo = ({ size = 34 }: { size?: number }) => {
  const petals = Array.from({ length: 12 });
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-label="People's Circle logo">
      <g>
        {petals.map((_, i) => (
          <ellipse
            key={i}
            cx="50"
            cy="20"
            rx="7"
            ry="17"
            fill={i % 2 === 0 ? "#0055FF" : "#2A7CFF"}
            transform={`rotate(${i * 30} 50 50)`}
          />
        ))}
        <circle cx="50" cy="50" r="14" fill="#FFD60A" />
        <circle cx="50" cy="50" r="6" fill="#050505" />
      </g>
    </svg>
  );
};

export default Logo;
